import { render, staticRenderFns } from "./ProviderDetail.vue?vue&type=template&id=824365e4&"
import script from "./ProviderDetail.vue?vue&type=script&lang=js&"
export * from "./ProviderDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProviderDetail.vue?vue&type=style&index=0&id=824365e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports